module.exports = __webpack_public_path__ + "static/img/afmCenterBanner.c187cd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/afmCenterBanner.png
// module id = 1MRZ
// module chunks = 1